import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { HeaderFilterDropdown } from './components/header-filter-dropdown.component';
import { ViewTypeSwitcher } from './components/view-type-switcher.component';

const filterAssets = [
	{
		id: 'filter_stream',
		title: 'Стрим',
	},
	{
		id: 'filter_news',
		title: 'Новость',
	},
	{
		id: 'filter_article',
		title: 'Статья',
	},
	{
		id: 'filter_tv',
		title: 'ТВ',
	},
];

const propTypes = {
	viewType: PropTypes.string,
};

const sortData = [
	{
		id: 'titleDesc',
		title: 'По названию (А — Я)',
	},
	{
		id: 'titleAsc',
		title: 'По названию (Я — А)',
	},
	{
		id: 'dateDesc',
		title: 'По дате (сначала новые)',
	},
	{
		id: 'dateAsc',
		title: 'По дате (сначала старые)',
	},
];

const textFieldStyle = {
	style: {
		width: '100%',
		maxWidth: 222,
		fontSize: 14,
		height: 38,
		paddingBottom: 5,
	},
	inputStyle: {
		fontSize: 14,
	},
	underlineStyle: {
		marginTop: -2,
	},
	hintStyle: {
		bottom: 12,
	},
};

export class MediaGalleryFilter extends React.Component {
	state = {
		searchText: '',
	};

	handleInputKeypress = e => {
		const { onChange } = this.props;
		const { searchText } = this.state;
		if (e.charCode !== 13) {
			return;
		}

		onChange('querySearch', {
			hintText: '',
			searchText: searchText.length > 0 ? searchText : null,
		});
	};

	changeView = type => {
		this.props.changeViewType({
			viewType: type,
		});
	};

	handleFilterChange = type => filter => {
		const { onChange } = this.props;
		onChange(type, filter);
	};

	render() {
		const { type, viewType, value } = this.props;
		const { searchText } = this.state;

		const topics = [{ id: '', name: 'Все' }, ...this.props.topics.edges.map(edge => edge.node)];

		const shows = [{ id: '', title: 'Все' }, ...filterAssets];

		return (
			<div className="header-filter">
				{type !== 'image' && (
					<HeaderFilterDropdown
						onValueChange={this.handleFilterChange('show')}
						dataSource={shows}
						value={value.show}
						fieldId="show"
						config={{
							label: 'Категория',
							text: 'title',
						}}
					/>
				)}
				<HeaderFilterDropdown
					dataSource={topics}
					fieldId="topic"
					value={value.topic}
					onValueChange={this.handleFilterChange('topic')}
					config={{ label: 'Тема', text: 'name' }}
				/>
				<HeaderFilterDropdown
					dataSource={sortData}
					fieldId="sort"
					value={value.sort}
					onValueChange={this.handleFilterChange('sort')}
					config={{ label: 'Сортировка', text: 'title' }}
				/>
				<div className="header-filter--item header-filter--search header-filter--item_right">
					<TextField
						{...textFieldStyle}
						hintText="Поиск"
						value={searchText}
						onKeyPress={this.handleInputKeypress}
						onChange={(_, v) => this.setState({ searchText: v })}
					/>
				</div>
				{type !== 'image' && <ViewTypeSwitcher value={viewType} onValueChange={this.changeView} />}
			</div>
		);
	}
}

MediaGalleryFilter.propTypes = propTypes;



// WEBPACK FOOTER //
// src/components/media/MediaGalleryFilter.js